import {Button, Col, Modal, Row} from "react-bootstrap";
import {
  generateForm,
  generateInitValues,
  generateValidationSchema,
} from "../../../../utils/AppFunction";
import React, {Dispatch, SetStateAction, useContext, useEffect, useState} from "react";
import {AppContext} from "../../../../appContext/AppContext";
import {XayDungKeHoachContext} from "../HoTroKyThuatChuyenMon";
import {Formik, Form} from "formik";
import {addPhieuKeHoach, searchdsCanBo, searchdsNhanSu, updatePhieuKeHoach} from "../services/services";
import {CODE, MAX_PAGE_SIZE, TYPE_WH, WF_TRACKER} from "../../../../utils/Constant";
import {toast} from "react-toastify";
import WfButton from "../../../../workflows/components/WfButton";
import TableThongTinKeHoach from "./TableThongTinKeHoach"
import {IconButtonSave} from "../../../../component/IconSvg";
import {formatDateDTO} from "../../../../utils/FormatUtils";
import {TypeKeHoach} from "../models/KeHoachModel";
import ModelHeader from "../../../../component/ModelHeader";
import DynamicComponent from "../../../../component/GenerateDynamicComponent";
import GenerateFormComponent from "../../../../component/generate-form/GenerateFormHTMLNoValid";
import FormThemVatTu from "./FormThemVatTu";
import DialogBienBanHoTro from "./DialogBienBanHoTro";
import LabelRequired from "../../../../component/LabelRequired";
import AutocompleteObjectV2 from "../../../../component/AutocompleteObjectV2";
import TableNhanLuc from "../../co-so-kb-cb/components/TableNhanLuc";
import {searchOptionNhanVien, searchOptionVaiTro} from "../../co-so-kb-cb/services/services";
import DuDoanKinhPhi from "./DuDoanKinhPhi";
import {STATUS_CODE} from "../constants/constansKeHoach";

interface Props {
  show: boolean;
  onHide: () => void;
  initialValues: any;
  setInitialValues: Dispatch<SetStateAction<any>>
  warehouseId?: any;
  type: TypeKeHoach;
}

const STAFF_TYPES = {
  RECIPIENT: 'recipientGroup',
  SUPPORT_STAFF: 'supportStaff'
};

const DialogPhieuKeHoach = (props: Props) => {
  const {show, onHide, warehouseId, setInitialValues, initialValues, type} = props;
  const {setIsLoading} = useContext(AppContext);
  const {dsKeHoach, setDsKeHoach, detailPhieuKeHoach, setDetailPhieuKeHoach} = useContext(XayDungKeHoachContext);
  const [isView, setIsView] = useState<boolean>(initialValues?.statusCode === STATUS_CODE.approved_done)
  const [listJsonGenerate, setListJsonGenerate] = useState<any>([]);
  const [listJsonGenerateVT, setListJsonGenerateVT] = useState<any>([]);
  const [initialValuesFormThemVT, setInitialValuesFormThemVT] = useState<any>({});
  const [indexRowEdit, setIndexRowEdit] = useState<number | null>(null);
  const [openDialogThemMoi, setOpenDialogThemMoi] = useState<boolean>(false);
  const [itemSelected, setItemSelected] = useState<any>();
  const [thanhVien, setThanhVien] = useState<any>([]);
  const [editingIndexTren, setEditingIndexTren] = useState<number | null>(null);
  const [vaiTro, setVaiTro] = useState<any>([]);
  const [selectedNhanSuTren, setSelectedNhanSuTren] = useState<any>(null);
  const [selectedTiepNhanHoTro, setSelectedTiepNhanHoTro] = useState<any>(null);
  const [selectedCanBoHoTro, setSelectedCanBoHoTro] = useState<any>(null);

  const [dataNhanLuc, setDataNhanLuc] = useState<any>({
    batchStaffList: [],
  });

  const [budget, setBudget] = useState<any>({
    totalBudget: '',
    studentPayPercent: '',
    studentPayAmount: '',
    stateBudgetPercent: '',
    stateBudgetAmount: ''
  });

  const getOptions = async () => {
    try {
      setIsLoading(true);
      const [nhanVien, vaiTroRes] = await Promise.all([
        searchOptionNhanVien({pageSize: MAX_PAGE_SIZE}),
        searchOptionVaiTro({pageSize: MAX_PAGE_SIZE}),
      ]);

      setThanhVien(nhanVien?.data?.data?.content ?? []);
      setVaiTro(vaiTroRes?.data?.data?.content ?? []);
    } catch (e) {
      console.error("Lỗi khi tải danh sách:", e);
      toast.error("Không thể tải danh sách nhân viên và vai trò");
    } finally {
      setIsLoading(false);
    }
  };

  // Hàm thêm hoặc cập nhật - lưu vào batchStaffList với type
  const handleAddOrUpdate = (itemSelected: any, staffType: string) => {
    const newItem = {
      personnel: itemSelected?.code || "",
      personnelName: itemSelected?.name || "",
      position: itemSelected?.position || "",
      positionName: itemSelected?.chucVu || "",
      unit: itemSelected?.unitName || itemSelected?.department || "",
      unitName: itemSelected?.unitName || itemSelected?.department || "",
      degree: "",
      degreeName: "",
      experience: "",
      currentCapacity: "",
      currentCapacityName: "",
      item: itemSelected,
      levelType: staffType, // Thêm trường type để phân biệt
    };

    if (editingIndexTren !== null) {
      const updatedList = [...dataNhanLuc.batchStaffList];
      updatedList[editingIndexTren] = newItem;
      setDataNhanLuc({...dataNhanLuc, batchStaffList: updatedList});
      setEditingIndexTren(null);
    } else {
      setDataNhanLuc({
        ...dataNhanLuc,
        batchStaffList: [newItem, ...dataNhanLuc.batchStaffList]
      });
    }

    setSelectedNhanSuTren(null);
    setSelectedTiepNhanHoTro(null);
    setSelectedCanBoHoTro(null);
  };

  // Hàm xóa - xóa từ batchStaffList
  const handleDelete = (index: number, staffType: string) => {
    // Lọc ra danh sách theo type
    const itemsOfType = dataNhanLuc.batchStaffList.filter((item: any) => item.levelType === staffType);
    const itemToDelete = itemsOfType[index];

    // Xóa item khỏi batchStaffList
    const updatedList = dataNhanLuc.batchStaffList.filter((item: any) => item !== itemToDelete);
    setDataNhanLuc({...dataNhanLuc, batchStaffList: updatedList});
    toast.success('Xóa thành công');
  };

  // Hàm lọc dữ liệu theo type để hiển thị trong bảng
  const getDataByType = (staffType: string) => {
    return dataNhanLuc.batchStaffList.filter((item: any) => item?.levelType === staffType);
  };

  useEffect(() => {
    getOptions();
  }, []);

  console.log(type)

  const handleFormSubmit = async (values: any) => {
    const dataSubmit = {
      ...values[type.formThongTinChung],
      type: TYPE_WH.IMPORT,
      doCreation: values?.[type.formThongTinChung]?.id ? formatDateDTO(values?.[type.formThongTinChung]?.doCreation) : formatDateDTO(new Date()),
      listOfInstructions: [...(dsKeHoach || [])].map(item => {
        return (
          {
            ...item,
            id: item?.id || null,
          }
        )
      }),
      ...budget,
      ...dataNhanLuc, // Chỉ có batchStaffList
      trackerCode: type.trackerCode,
      termModelType: type?.formThongTinChung,
    };

    console.log('Data submit:', dataSubmit);
    try {
      setIsLoading(true);
      const id = values[type.formThongTinChung]?.id;
      const {data} = id ? await updatePhieuKeHoach(id, dataSubmit) : await addPhieuKeHoach(dataSubmit);
      if (CODE.SUCCESS === data?.code) {
        setIsView(true);
        toast.success(((id) ? "Cập nhật" : "Thêm") + " thành công");
      } else {
        let errorMesage = data?.data?.[0]?.message || "Xảy ra lỗi, vui lòng thử lại!";
        toast.warning(errorMesage);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      toast.warning("Xảy ra lỗi, vui lòng thử lại!");
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const getDsItems = async () => {
    try {
      const data = await searchdsNhanSu(initialValues?.id);
      setDataNhanLuc({batchStaffList: data?.data?.data ?? []})
    } catch (e) {

    }
  }
  useEffect(() => {
    initialValues?.slipId && getDsItems();
  }, [initialValues?.id]);

  useEffect(() => {
    updateForm();
  }, []);

  const updateForm = async () => {
    if (!type?.formThongTinChung) return;
    const data = await generateForm(type?.formThongTinChung, setIsLoading);
    setListJsonGenerate(data || []);
    setInitialValues({...generateInitValues(data), ...initialValues?.slip ?? {}, ...initialValues});
    setBudget({
      totalBudget: initialValues?.totalBudget ?? '',
      studentPayPercent: initialValues?.studentPayPercent ?? '',
      studentPayAmount: initialValues?.studentPayAmount ?? '',
      stateBudgetPercent: initialValues?.stateBudgetPercent ?? '',
      stateBudgetAmount: initialValues?.stateBudgetAmount ?? ''
    })
  };

  const handler = (data: any) => {
    setInitialValuesFormThemVT({
      ...initialValuesFormThemVT,
      ...data,
      isFirstChange: true,
    });
  };

  const handleCloseDialog = () => {
    setOpenDialogThemMoi(false);
  };

  // Tạo hàm tạo columns động cho mỗi bảng
  const createColumnsForTable = (staffType: string) => [
    {
      name: "STT",
      field: "",
      headerStyle: {
        width: 80,
      },
      cellStyle: {
        textAlign: "center",
      },
      render: (row: any, index: number, stt: number) => stt,
    },
    ...(!isView ?
      [
        {
          name: "Thao tác",
          field: "",
          headerStyle: {
            width: 100,
          },
          cellStyle: {
            textAlign: "center",
            justifyContent: "center"
          },
          render: (row: any, index: number, stt: number) =>
            <div className="d-flex justify-content-center">
              <i
                onClick={() => handleDelete(index, staffType)}
                className="bi bi-trash3-fill text-danger cursor-pointer"
                style={{cursor: 'pointer'}}
                title="Xóa"
              ></i>
            </div>
        },
      ] : []),
    {
      name: "Họ tên",
      field: "personnelName",
      headerStyle: {
        minWidth: 120,
      },
      cellStyle: {
        textAlign: "left",
      },
      render: (row: any) => row.personnelName || row.item?.personnelName || '',
    },
    {
      name: "Chức danh",
      field: "position",
      headerStyle: {
        minWidth: 200,
      },
      cellStyle: {
        textAlign: "left",
      },
      render: (row: any) => row.position || row.item?.position || '',
    },
    {
      name: "Đơn vị",
      field: "unitName",
      headerStyle: {
        minWidth: 120,
      },
      cellStyle: {
        textAlign: "left",
      },
      render: (row: any) => row.unitName || row.item?.unitName || '',
    },
    {
      name: "Trình độ chuyên môn",
      field: "quantityOfficer",
      headerStyle: {
        minWidth: 120,
      },
      cellStyle: {
        textAlign: "left",
      },
      render: (row: any) => row.quantityOfficer || row.item?.quantityOfficer || '',
    },
  ];

  return (
    <Modal
      centered
      show={show}
      // onHide={onHide}
      size="xl"
      fullscreen
      className="page-full spaces h-calc-vh-50 dialog-coso-kb-cb"
    >
      <Formik
        enableReinitialize
        validateOnChange={true}
        validateOnBlur={true}
        initialValues={{[type.formThongTinChung]: initialValues}}
        validationSchema={generateValidationSchema(listJsonGenerate, type.formThongTinChung)}
        onSubmit={handleFormSubmit}
      >
        {({values, touched, errors, setValues, handleChange, handleSubmit, setFieldValue}) => (
          <>
            <Form onSubmit={handleSubmit}>
              <ModelHeader onHide={onHide} title={`Bổ sung thông tin kỹ thuật`}/>
              <Modal.Body className="spaces p-0 bg-white">
                <div className="spaces px-10">
                  <GenerateFormComponent
                    isView={isView}
                    listFieldAuto={listJsonGenerate}
                    handleChange={handleChange}
                    setValues={setValues}
                    values={values}
                    touched={touched}
                    errors={errors}
                    propsRenderButton={handler}
                    lstSelectedRenderButton={dsKeHoach}
                    setFieldValue={setFieldValue}
                    modelID={type.formThongTinChung}
                    customComponent={DynamicComponent}
                    warehouseId={warehouseId}
                  />
                  <hr/>
                  <h4 className="text-title fw-bold fs-5 spaces mb-5">
                    Đối tượng tiếp nhận hỗ trợ kĩ thuật chuyên môn
                  </h4>
                  {!isView && (
                    <Row>
                      <Col lg={1} className="spaces">
                        <div className="spaces pt-10 min-w-135">
                          <div className="spaces mt-1">
                            <LabelRequired className="min-w-100px" label="Nhân sự"/>
                          </div>
                        </div>
                      </Col>
                      <Col lg={10} className="spaces pl-36">
                        <AutocompleteObjectV2
                          options={thanhVien}
                          value={selectedTiepNhanHoTro}
                          isSearchDefauilt={true}
                          name="WmsCode"
                          onChange={(options: any) => setSelectedTiepNhanHoTro(options)}
                          className="autocomplete-custom-renderform mt-8 radius spaces width-100 h-29"
                          isClearable={true}
                          placeholder="Chọn nhân sự..."
                        />
                      </Col>
                      <Col lg={1}>
                        <div className="d-flex mt-8 spaces align-items-center">
                          <Button
                            className="btn-fill spaces min-w-90px btn btn-primary"
                            onClick={() => handleAddOrUpdate(selectedTiepNhanHoTro, STAFF_TYPES.RECIPIENT)}
                            type="button"
                          >
                            <i className="bi bi-plus-lg text-pri fs-3"></i>
                            {editingIndexTren !== null ? 'Cập nhật' : 'Thêm'}
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  )}
                  <TableNhanLuc
                    columns={createColumnsForTable(STAFF_TYPES.RECIPIENT)}
                    isView={isView}
                    dsItems={getDataByType(STAFF_TYPES.RECIPIENT)}
                  />

                  <h4 className="text-title fw-bold fs-5 spaces mb-5">
                    Cán bộ hỗ trợ kĩ thuật chuyên môn
                  </h4>
                  {!isView && (
                    <Row>
                      <Col lg={1} className="spaces">
                        <div className="spaces pt-10 min-w-135">
                          <div className="spaces mt-1">
                            <LabelRequired className="min-w-100px" label="Nhân sự"/>
                          </div>
                        </div>
                      </Col>
                      <Col lg={10} className="spaces pl-36">
                        <AutocompleteObjectV2
                          options={thanhVien}
                          value={selectedCanBoHoTro}
                          isSearchDefauilt={true}
                          name="WmsCode"
                          onChange={(options: any) => setSelectedCanBoHoTro(options)}
                          className="autocomplete-custom-renderform mt-8 radius spaces width-100 h-29"
                          isClearable={true}
                          placeholder="Chọn nhân sự..."
                        />
                      </Col>
                      <Col lg={1}>
                        <div className="d-flex mt-8 spaces align-items-center">
                          <Button
                            className="btn-fill spaces min-w-90px btn btn-primary"
                            onClick={() => handleAddOrUpdate(selectedCanBoHoTro, STAFF_TYPES.SUPPORT_STAFF)}
                            type="button"
                          >
                            <i className="bi bi-plus-lg text-pri fs-3"></i>
                            {editingIndexTren !== null ? 'Cập nhật' : 'Thêm'}
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  )}
                  <TableNhanLuc
                    columns={createColumnsForTable(STAFF_TYPES.SUPPORT_STAFF)}
                    isView={isView}
                    dsItems={getDataByType(STAFF_TYPES.SUPPORT_STAFF)}
                  />

                  <div className="">
                    <DuDoanKinhPhi
                      initialValues={initialValues}
                      setInitialValues={setInitialValues}
                      type={type}
                      dataKinhPhi={budget}
                      setDataKinhPhi={setBudget}
                      isView={isView}
                    />
                  </div>
                </div>
              </Modal.Body>
              <div className="bottom-button d-flex justify-content-start w-100 bg-white spaces py-6 pl-5">
                {(values.keHoach?.id || detailPhieuKeHoach?.id) && !detailPhieuKeHoach?.isView && (
                  <WfButton
                    additionalFunc={(data: any) => {
                      setDetailPhieuKeHoach({
                        ...detailPhieuKeHoach,
                        status: data?.currCode,
                        statusCode: data?.currCode,
                        statusId: data?.currId,
                      })
                    }}
                    tracker={type.trackerCode}
                    onHide={onHide}
                    objectId={values.keHoach?.id || detailPhieuKeHoach?.id}
                  />
                )}
                {!isView &&
                    <Button type="submit" className="btn btn-fill min-w-120px spaces mx-3">
                        <IconButtonSave/> Lưu
                    </Button>
                }
              </div>
            </Form>
          </>
        )}
      </Formik>
      {openDialogThemMoi && <DialogBienBanHoTro
          type={type}
          show={openDialogThemMoi}
          onHide={handleCloseDialog}
          initialValues={{keHoach: {...itemSelected}}}
          setInitialValues={setItemSelected}
      />}
    </Modal>
  );
};

export default DialogPhieuKeHoach;